import { render, staticRenderFns } from "./repair.vue?vue&type=template&id=05fe71ef&scoped=true&"
import script from "./repair.vue?vue&type=script&lang=js&"
export * from "./repair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fe71ef",
  null
  
)

export default component.exports